import React, { Component } from 'react';

import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from 'reactstrap';

class ConfirmationRateModal extends Component {

  onConfirm = () => {
    this.props.onConfirm();
  };

  onEditRate = () => {
    this.props.toggle();
  };

  render() {
    const { isOpen, toggle, payRate } = this.props;

    return (
      <div className="confirmationModal">
        <Modal isOpen={isOpen} toggle={toggle} className='confirmation-modal-content'>
          <ModalHeader toggle={toggle}>Confirm Pay Rate</ModalHeader>
          <ModalBody>
            Please confirm the pay rate is <span className='font-weight-bold'>${payRate} per hour</span> for this event.
          </ModalBody>
          <ModalFooter style={{
            justifyContent: 'space-between',
            paddingRight: '40px',
            paddingLeft: '40px'
          }}>
            <button className='btn btn-link link-button pl-0 ml-0' onClick={this.onEditRate}>Edit Rate</button>
            <button className='btn btn-danger bold-button' onClick={this.onConfirm}>Confirm</button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default ConfirmationRateModal;